module.exports = __webpack_public_path__ + "img/faceCheck-default.4e14a8f3.jpeg";